import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ZapIcon } from 'lucide-react';
export function Pricing() {
  const features = ['All qualification frameworks', 'Unlimited call processing', 'Full HubSpot sync', 'Slack review workflows', 'Priority support from the founding team'];
  return <section id="pricing" className="py-28 md:py-36 bg-white border-t border-slate-100" data-id="element-301" data-mp="2jkxgpa6e7wwz">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12" data-id="element-302" data-mp="1vujz6dlfpggn">
        <div className="text-center mb-12" data-id="element-303" data-mp="1rsyieh5s4i16">
          <div className="text-xs uppercase tracking-[0.2em] font-medium text-teal-600 mb-4" data-id="element-304" data-mp="1ru9h42kdazlf">
            Pricing
          </div>
          <h2 className="text-4xl md:text-5xl font-medium text-slate-900 mb-6" data-id="element-305" data-mp="20t4qtommerth">
            Free during early access
          </h2>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="max-w-lg mx-auto bg-white border border-slate-200 rounded-2xl p-10 shadow-sm text-center" data-id="element-306" data-mp="3h639gdduwyqk">
          <div className="flex items-baseline justify-center mb-4" data-id="element-307" data-mp="9t0b3chvxrhi">
            <span className="text-5xl font-medium text-slate-900" data-id="element-308" data-mp="eqac7pemzrl6">$0</span>
            <span className="text-lg text-slate-500 ml-2" data-id="element-309" data-mp="3d9h8nhogug19">
              /month during beta
            </span>
          </div>

          <p className="text-slate-600 text-base mt-4 mb-8" data-id="element-310" data-mp="3i93hzg16bc4s">
            All features included. No credit card required. We are building
            Kinase with our first customers and want your feedback.
          </p>

          <ul className="space-y-3 mb-8 text-left" data-id="element-311" data-mp="3rz6brig4cu46">
            {features.map((feature, i) => <li key={i} className="flex items-start" data-id="element-312" data-mp="2ui7li5lrvsr7" data-mpi={i}>
                <CheckIcon className="w-5 h-5 text-teal-500 mr-3 flex-shrink-0 mt-0.5" data-id="element-313" data-mp="2zh13obc087xp" />
                <span className="text-slate-600 text-sm" data-id="element-314" data-mp="2rgl6dghfp73a">{feature}</span>
              </li>)}
          </ul>

          <a href="https://app.getkinase.com" className="w-full py-3 bg-teal-500 hover:bg-teal-400 text-white rounded-lg font-medium transition-colors flex items-center justify-center space-x-2 shadow-sm shadow-teal-500/20" data-id="element-315" data-mp="2mijnownx79sc">
            <ZapIcon className="w-4 h-4" data-id="element-316" data-mp="28i0l45284vxk" />
            <span data-id="element-317" data-mp="28j1ve7bf1ee8">Request free early access</span>
          </a>
        </motion.div>

        <p className="text-sm text-slate-400 mt-6 text-center" data-id="element-318" data-mp="23jpbnvfucnfv">
          Paid plans will be introduced after beta. Early access customers will
          be grandfathered.
        </p>
      </div>
    </section>;
}